import { registerLocaleData } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import ptBr from '@angular/common/locales/pt';
import { DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import {
  MAT_CHECKBOX_DEFAULT_OPTIONS,
  MatCheckboxDefaultOptions,
  MatCheckboxModule,
} from '@angular/material/checkbox';
import { MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldModule,
} from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import {
  MatPaginatorIntl,
  MatPaginatorModule,
} from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TextMaskModule } from 'angular2-text-mask';
import { MatTableExporterModule } from 'mat-table-exporter';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { AbastecimentoHorarioComponent } from './abastecimento-horario/abastecimento-horario.component';
import { DeleteRestrictionComponent } from './abastecimento-horario/components/delete-restriction/delete-restriction.component';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CentralBloqueiosComponent } from './central-bloqueios/central-bloqueios.component';
import { ListaBloqueiosComponent } from './central-bloqueios/lista-bloqueios/lista-bloqueios.component';
import { CpfFormatPipe } from './components/cpf-format.pipe';
import { ExtendedMatTableComponent } from './components/extended-mat-table/extended-mat-table.component';
import { MultiValorColumnComponent } from './components/extended-mat-table/multi-valor-column.component';
import { MatSpinnerOverlayComponent } from './components/mat-spinner-overlay/mat-spinner-overlay.component';
import { MatPaginatorIntlBr } from './components/MatPaginatorIntlBr';
import { MensagemRetornoComponent } from './components/mensagem-retorno/mensagem-retorno.component';
import { SnackbarComponent } from './components/snackbar/snackbar.component';
import { ConfiguracaoNFeComponent } from './configuracao-nfe/configuracao-nfe.component';
import { FiltroFrotaComponent } from './frota/filtro-frota/filtro-frota.component';
import { PesquisaFrotaComponent } from './frota/pesquisa-frota/pesquisa-frota.component';
import { LoginComponent } from './login/login.component';
import { FiltroMotoristaComponent } from './motorista/filtro-motorista/filtro-motorista.component';
import { PesquisaMotoristaComponent } from './motorista/pesquisa-motorista/pesquisa-motorista.component';
import { PerfisModule } from './perfis/perfis.module';
import { PrecoCombustivelComponent } from './preco-combustivel/preco-combustivel.component';
import { CorpoComponent } from './precos-combustiveis/corpo/corpo.component';
import { FooterComponent } from './precos-combustiveis/footer/footer.component';
import { MenuCombustiveisComponent } from './precos-combustiveis/menu-combustiveis/menu-combustiveis.component';
import { ModalAjudaComponent } from './precos-combustiveis/modal-ajuda/modal-ajuda.component';
import { ModalAjustePrecoNegociadoComponent } from './precos-combustiveis/modal-ajuste-preco-negociado/modal-ajuste-preco-negociado.component';
import { ModalAjustePrecoRedeEspecialComponent } from './precos-combustiveis/modal-ajuste-preco-rede-especial/modal-ajuste-preco-rede-especial.component';
import { ModalAjustePrecoUnitarioComponent } from './precos-combustiveis/modal-ajuste-preco-unitario/modal-ajuste-preco-unitario.component';
import { MostrarPrecoComponent } from './precos-combustiveis/mostrar-preco/mostrar-preco.component';
import { NotificacoesComponent } from './precos-combustiveis/notificacoes/notificacoes.component';
import { DetalheRegistroTransacaoComponent } from './registro-transacoes/detalhe-registro-transacao/detalhe-registro-transacao.component';
import { FiltroCentralBloqueioComponent } from './registro-transacoes/filtro-central-bloqueio/filtro.component';
import { FiltroComponent } from './registro-transacoes/filtro/filtro.component';
import { RegistroTransacoesComponent } from './registro-transacoes/registro-transacoes.component';
import { RelatoriosComponent } from './relatorios/relatorios.component';
import { SnackBarService } from './services/snack-bar-service.service';
import { BreadcrumbTitleComponent } from './shared/components/breadcrumb-title/breadcrumb-title.component';
import { FiltroSubfrotaComponent } from './subFrota/filtro-subfrota/filtro-subfrota.component';
import { PesquisaSubfrotaComponent } from './subFrota/pesquisa-subfrota/pesquisa-subfrota.component';
import { SubFrotaSalvarAbastecimentoComponent } from './subFrota/sub-frota-salvar-abastecimento/sub-frota-salvar-abastecimento.component';
import { SubfrotaAprovacaoAbastecimentoEditadoComponent } from './subFrota/subfrota-aprovacao-abastecimento-editado/subfrota-aprovacao-abastecimento-editado.component';
import { SubfrotaEditAbastecimentosComponent } from './subFrota/subfrota-edit-abastecimentos/subfrota-edit-abastecimentos.component';
import { SubfrotaEditComponent } from './subFrota/subfrota-edit/subfrota-edit.component';
import { SubfrotaRelatorioAbastecimentosAlteradosComponent } from './subFrota/subfrota-relatorio-abastecimentos-alterados/subfrota-relatorio-abastecimentos-alterados.component';
import { SubfrotaShowComponent } from './subFrota/subfrota-show/subfrota-show.component';
import { SubfrotaService } from './subFrota/subfrota.service';
import { SubfrotaComponent } from './subFrota/subfrota/subfrota.component';
import { UploadcsvModule } from './upload-csv-posto/uploadcsv.module';
import { CnpjValidatorDirective } from './validator/cnpj-validator.directive';
import { FiltroVeiculoComponent } from './veiculo/filtro-veiculo/filtro-veiculo.component';
import { PesquisaVeiculoComponent } from './veiculo/pesquisa-veiculo/pesquisa-veiculo.component';
import { VendaArlaModule } from './venda-arla/venda-arla.module';

registerLocaleData(ptBr);
@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    PrecoCombustivelComponent,
    //MatSpinnerOverlayComponent,
    //MatSpinnerOverlayComponent,
    MensagemRetornoComponent,
    SubfrotaEditComponent,
    SubfrotaComponent,
    FiltroFrotaComponent,
    PesquisaFrotaComponent,
    SnackbarComponent,
    DeleteRestrictionComponent,
    SubfrotaShowComponent,
    CnpjValidatorDirective,
    CorpoComponent,
    ModalAjudaComponent,
    NotificacoesComponent,
    MenuCombustiveisComponent,
    MostrarPrecoComponent,
    ModalAjustePrecoUnitarioComponent,
    ModalAjustePrecoNegociadoComponent,
    SubfrotaComponent,
    SubfrotaEditAbastecimentosComponent,
    SubfrotaRelatorioAbastecimentosAlteradosComponent,
    SubFrotaSalvarAbastecimentoComponent,
    SubfrotaAprovacaoAbastecimentoEditadoComponent,
    ConfiguracaoNFeComponent,
    ModalAjustePrecoRedeEspecialComponent,
    FooterComponent,
    RelatoriosComponent,
    ExtendedMatTableComponent,
    MultiValorColumnComponent,
    RegistroTransacoesComponent,
    AbastecimentoHorarioComponent,
    FiltroComponent,
    FiltroCentralBloqueioComponent,
    FiltroVeiculoComponent,
    PesquisaVeiculoComponent,
    FiltroMotoristaComponent,
    PesquisaMotoristaComponent,
    DetalheRegistroTransacaoComponent,
    CentralBloqueiosComponent,
    CpfFormatPipe,
    PesquisaSubfrotaComponent,
    FiltroSubfrotaComponent,
    ListaBloqueiosComponent,
    BreadcrumbTitleComponent,
  ],
  imports: [
    BrowserModule,
    MatDividerModule,
    AppRoutingModule,
    NgbModule,
    HttpClientModule,
    NgxSkeletonLoaderModule,
    FormsModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    CurrencyMaskModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatDialogModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatButtonToggleModule,
    MatSlideToggleModule,
    MatMenuModule,
    MatPaginatorModule,
    MatRadioModule,
    MatSnackBarModule,
    MatSelectModule,
    MatSortModule,
    MatTableExporterModule,
    MatTableModule,
    MatTabsModule,
    MatTooltipModule,
    MatOptionModule,
    BrowserAnimationsModule,
    TextMaskModule,
    MatCheckboxModule,
    PerfisModule,
    VendaArlaModule,
    UploadcsvModule,
    MatDatepickerModule,
    MatInputModule,
    MatNativeDateModule,
    MatCardModule,
    MatBadgeModule,
    BrowserAnimationsModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatExpansionModule,
    MatGridListModule,
    MatSpinnerOverlayComponent,
  ],
  providers: [
    SnackBarService,
    { provide: MatPaginatorIntl, useClass: MatPaginatorIntlBr },
    {
      provide: MAT_CHECKBOX_DEFAULT_OPTIONS,
      useValue: { clickAction: 'check' } as MatCheckboxDefaultOptions,
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline' },
    },
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'BRL' },
    SubfrotaService,
  ],
    exports: [MatSpinnerOverlayComponent, ExtendedMatTableComponent],
  bootstrap: [AppComponent],
})
export class AppModule {}
